import React from "react";
import {
  Button,
  Checkbox,
  FormControl,
  IconButton,
  InputAdornment,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
} from "@mui/material";
import { PACKAGE_OPTIONS_LIST } from "../caterer-list";
import { ICatererListFilter } from "../caterer-list.typings";

interface ICatererListFilterProps extends ICatererListFilter{
  count: number;
  onOpenFilter(): void;
}

export function CatererListFilter({
  count,
  search,
  dietary,
  sortBy,
  packageOption,
  cuisine,
  cuisineList,
  setCuisine,
  setPackageOption,
  setSortBy,
  setDietary,
  setSearch,
  onOpenFilter,
  onClear,
}: ICatererListFilterProps) {
  return (
    <div className="listing-filter-secondary">
      <div className="container">
        <div className="row">
          <div className="col-12">
            {/* Mobile Filter Button and Results Count */}
            <div className="d-flex d-lg-none align-items-center justify-content-between mb-3">
              <Button
                onClick={onOpenFilter}
                className="cater-list-filter-btn"
                variant="outlined"
                startIcon={<img src="../assets/images/icon-filter.svg" className="img-fluid" alt="Filter" />}
                title="Filter">
                Filter
              </Button>
              {count > 0 && (
                <div className="caterer-count-mobile">
                  <h4 className="mb-0">{count} Caterers Found</h4>
                </div>
              )}
            </div>

            {/* Desktop Filter Controls */}
            <div className="d-none d-lg-flex align-items-center">
              <TextField
                className="form-control lfs-search lfs-item"
                placeholder="Search by Caterers Name"
                value={search}
                onChange={setSearch}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <img src="../assets/images/search.svg" />
                    </InputAdornment>
                  ),
                }}
              />

              <FormControl className="lfs-deitary lfs-item">
                <Select
                  labelId="Time"
                  id="time"
                  className="hours-dropdown"
                  value={dietary}
                  onChange={setDietary}>
                  <MenuItem className="lfs-menuitem" value={"Dietary"}>
                    <img src="../assets/images/diatry.svg" className="img-fluid" alt="Head Count" />
                    All Dietary
                  </MenuItem>

                  <MenuItem className="lfs-menuitem" value={"Vegetarian"}>
                    <img src="../assets/images/diatry.svg" className="img-fluid" alt="Dietary Icon" />
                    {"Vegetarian"}
                  </MenuItem>
                  <MenuItem className="lfs-menuitem" value={"Gluten-free"}>
                    <img src="../assets/images/diatry.svg" className="img-fluid" alt="Dietary Icon" />
                    {"Gluten-free"}
                  </MenuItem>
                </Select>
              </FormControl>

              <FormControl className="lfs-option lfs-item">
                <Select
                  labelId="demo-multiple-checkbox-label"
                  id="demo-multiple-checkbox"
                  multiple
                  value={packageOption}
                  onChange={setPackageOption}
                  input={<OutlinedInput />}
                  renderValue={(selected) =>
                    selected[0] === "options" && selected.length === 1
                      ? "All Options"
                      : selected.length - 1 + " Selected"
                  }>
                  {PACKAGE_OPTIONS_LIST.map((item) => (
                    <MenuItem className="lfs-select-item" key={item?.value} value={item?.value}>
                      <Checkbox className="p-0" checked={packageOption.indexOf(item?.value) > -1} />
                      <ListItemText primary={item?.value} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl className="lfs-cuisnes lfs-item">
                <Select
                  labelId="demo-multiple-checkbox-label"
                  id="demo-multiple-checkbox"
                  multiple
                  value={cuisine}
                  onChange={setCuisine}
                  input={<OutlinedInput />}
                  renderValue={(selected) =>
                    selected[0] === "All Cuisines" && selected.length === 1
                      ? "All Cuisines"
                      : selected.length - 1 + " Selected"
                  }>
                  {cuisineList
                    ? cuisineList.map((item) => (
                        <MenuItem className="lfs-select-item" key={item?._id} value={item?._id}>
                          <Checkbox className="p-0" checked={cuisine.indexOf(item?._id) > -1} />
                          <ListItemText primary={item?.cuisineName} />
                        </MenuItem>
                      ))
                    : null}
                </Select>
              </FormControl>

              <FormControl className="lfs-sort lfs-item">
                <Select
                  labelId="Time"
                  id="time"
                  className="hours-dropdown"
                  value={sortBy}
                  onChange={setSortBy}>
                  <MenuItem className="lfs-menuitem" value={"Distance"}>
                    <p>Sort by :&nbsp;</p>Distance
                  </MenuItem>
                  <MenuItem className="lfs-menuitem" value={"1"}>
                    CaterCash High
                  </MenuItem>
                  <MenuItem className="lfs-menuitem" value={"-1"}>
                    CaterCash Low
                  </MenuItem>
                </Select>
              </FormControl>
              
              <Button className="lfs-clear-btn" variant="contained" color="primary" onClick={onClear}>
                Clear
              </Button>
            </div>
          </div>
        </div>
        
        {/* Desktop Results Count - Separate Row */}
        {(count > 0) && (
          <div className="row d-none d-lg-block">
            <div className="col-12">
              <h3 className="caterer-count-desktop">{count} Caterers Found</h3>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}